<template>
  <VModal
    v-bind="modalOptions"
    @before-open="beforeOpen"
  >
    <div :class="$style.root">
      <UiButton
        v-if="buttonClose"
        :class="$style.buttonClose"
        :depressed="true"
        size="small"
        @click="close"
      >
        <UiIcon
          :class="$style.iconClose"
          :color-inheritance="true"
          name="cross"
        />
      </UiButton>

      <div
        v-if="$scopedSlots.lessonInfo"
        :class="$style.lessonInfo"
      >
        <slot name="lessonInfo" />
      </div>

      <div
        v-if="$scopedSlots.heading"
        :class="{
          [$style.heading]: true,
          [$style.underline]: ($scopedSlots.default && modalOptions.underline),
        }"
      >
        <slot name="heading" />
      </div>

      <div
        v-if="$scopedSlots.default"
        :class="$style.default"
      >
        <slot name="default" />
      </div>

      <div
        v-if="$scopedSlots.controls"
        :class="{
        [$style.controls]: true,
        [$style.controls_modal_style]: options.controls_modal_style
        }"
      >
        <slot name="controls" />
      </div>
    </div>
  </VModal>
</template>

<script>
  import UiIcon from '@/components/UiIcon';
  import UiButton from '@/components/UiButton';

  const OPTIONS_DEFAULT = {
    height: 'auto',
    adaptive: true,
    scrollable: true,
    underline: true,
    margins_big: false,
  };

  export default {
    name: 'UiModal',
    components: {
      UiIcon,
      UiButton,
    },
    props: {
      options: {
        type: Object,
        default: null,
      },
      buttonClose: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      modalOptions() {
        return {
          ...OPTIONS_DEFAULT,
          ...this.options,
        };
      },
    },
    methods: {
      beforeOpen(context) {
        this.$emit('before-open', context);
      },
      close() {
        const { name } = this.modalOptions;
        if (!name) return;
        this.$modal.hide(name);
      },
    },
  };
</script>

<style lang="scss" module>
  .root {
    position: relative;
  }

  .buttonClose {
    position: absolute;
    top: 10px;
    right: 5px;
    z-index: 1;

    &:hover {
      color: $colorDanger;
      transform: rotate(180deg);
    }
  }

  .iconClose {
    font-size: 16px;
  }

  .underline {
    border-bottom: 1px solid $colorGray1;
  }

  .heading {
    padding: 15px 15px 10px;
    font-size: 18px;
    font-weight: 600;
  }

  .default {
    padding: 15px;
    font-size: 14px;

    @include media('xs') {
      font-size: 16px;
    }
  }

  .controls {
   min-height: 35px;
    display: flex;
  }

  .controls_modal_style {

    border: 1px solid $colorGray1;
    margin: 0 30px 30px 30px;
  }

</style>
